import * as Styled from './styles';
import { Props } from '../interfaces';

function SecondaryButton({ show, onClick, children }: Props) {
  return (
    show &&
    (onClick ? (
      <Styled.SecondaryButton onClick={onClick} variant="subtle">
        {children}
      </Styled.SecondaryButton>
    ) : (
      <Styled.SecondaryTypography>{children}</Styled.SecondaryTypography>
    ))
  );
}

export default SecondaryButton;
